import React, { useEffect, useRef } from "react";
import Select from "react-select";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import CompanyInformation from "../../../components/StoreConfig/CompanyInformation";
import Taxes from "../../../components/StoreConfig/Taxes";
import Currency from "../../../components/StoreConfig/Currency";
import PaymentTypes from "../../../components/StoreConfig/PaymentTypes";
import PriceRules from "../../../components/StoreConfig/PriceRules";
import OrdersAndDeliveries from "../../../components/StoreConfig/OrdersAndDeliveries";
import Sales from "../../../components/StoreConfig/Sales";
import SuspendedSalesLayways from "../../../components/StoreConfig/SuspendedSalesLayways";
import Receipt from "../../../components/StoreConfig/Receipt";
import ProfitCalculation from "../../../components/StoreConfig/ProfitCalculation";
import Barcodes from "../../../components/StoreConfig/Barcodes";
import CustomerLoyalty from "../../../components/StoreConfig/CustomerLoyalty";
import PriceTiers from "../../../components/StoreConfig/PriceTiers";
import IDNumbers from "../../../components/StoreConfig/IDNumbers";
import Items from "../../../components/StoreConfig/Items";
import Employee from "../../../components/StoreConfig/Employee";
import StoreAccount from "../../../components/StoreConfig/StoreAccount";
import DisableModules from "../../../components/StoreConfig/DisableModules";
import ApplicationSettings from "../../../components/StoreConfig/ApplicationSettings";
import EmailSettings from "../../../components/StoreConfig/EmailSettings";
import SingleSignOnInfo from "../../../components/StoreConfig/SingleSignOnInfo";
import WorkOrder from "../../../components/StoreConfig/WorkOrder";
import LookAPIIntergration from "../../../components/StoreConfig/LookAPIIntergration";

import {CUSTOM_SELECT_DROPDOWN_STYLE} from "../../../common/Constant";
import { useState } from "react";
import Loader from "../../../components/Loader/Loader";
import { Link } from "react-router-dom";
import stringSimilarity from "string-similarity";

const FormElements = (props) => {
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [companyInformation, setCompanyInformation] = useState(false);
  const [visibleTax, setVisibleTax] = useState(false);
  const [visibleCurrency, setVisibleCurrency] = useState(false);
  const [visiblePaymentTypes, setVisiblePaymentTypes] = useState(false);
  const [visiblePriceRules, setVisiblePriceRules] = useState(false);
  const [visibleOrdersAndDeliveries, setVisibleOrdersAndDeliveries] =
    useState(false);
  const [visibleSales, setVisibleSales] = useState(false);
  const [visibleSuspendedSalesLayways, setVisibleSuspendedSalesLayways] =
    useState(false);
  const [visibleReceipt, setVisibleReceipt] = useState(false);
  const [visibleProfitCalculation, setVisibleProfitCalculation] =
    useState(false);
  const [visibleBarcodes, setVisibleBarcodes] = useState(false);
  const [visibleCustomerLoyalty, setVisibleCustomerLoyalty] = useState(false);
  const [visiblePriceTiers, setVisiblePriceTiers] = useState(false);
  const [visibleIDNumbers, setVisibleIDNumbers] = useState(false);
  const [visibleItems, setVisibleItems] = useState(false);
  const [visibleEmployee, setVisibleEmployee] = useState(false);
  const [visibleStoreAccount, setVisibleStoreAccount] = useState(false);
  const [visibleDisableModules, setVisibleDisableModules] = useState(false);
  const [visibleApplicationSettings, setVisibleApplicationSettings] =
    useState(false);
  const [visibleEmailSettings, setVisibleEmailSettings] = useState(false);
  const [visibleSingleSignOnInfo, setVisibleSingleSignOnInfo] = useState(false);
  const [visibleWorkOrder, setVisibleWorkOrder] = useState(false);
  const [visibleLookAPIIntegration, setVisibleLookAPIIntegration] =
    useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const optionList = [
    {
      value: "1",
      label: "Company Information",
      condition: "COMPANYINFORMATION",
    },
    {
      value: "2",
      label: "Taxes",
      condition: "TAXES",
    },
    { value: "3", label: "Currency", condition: "CURRENCY" },
    { value: "4", label: "Payment Types", condition: "PAYMENTTYPES" },
    { value: "5", label: "Price Rules", condition: "PRICERULES" },
    {
      value: "6",
      label: "Orders And Deliveries",
      condition: "ORDERSANDDELIVERIES",
    },
    { value: "7", label: "Sales", condition: "SALES" },
    {
      value: "8",
      label: "Suspended Sales/ Layways",
      condition: "SUSPENDEDSALES",
    },
    { value: "9", label: "Receipt", condition: "RECEIPT" },
    {
      value: "10",
      label: "Profit Calculation",
      condition: "PROFITCALCULATION",
    },
    { value: "11", label: "Barcode", condition: "BARCODE" },
    { value: "12", label: "Customer Loyalty", condition: "CUSTOMERLOYALTY" },
    { value: "13", label: "Price Tiers", condition: "PRICETIERS" },
    { value: "14", label: "ID Numbers", condition: "IDNUMBERS" },
    { value: "15", label: "Items", condition: "ITEMS" },
    { value: "16", label: "Employee", condition: "EMPLOYEE" },
    { value: "17", label: "Store Account", condition: "STOREACCOUNT" },
    { value: "18", label: "Disable Modules", condition: "DISABLEMODULES" },
    {
      value: "19",
      label: "Application Settings",
      condition: "APPLICATIONSETTINGS",
    },
    { value: "20", label: "Email Settings", condition: "EMAILSETTINGS" },
    {
      value: "21",
      label: "Single Sign On (SSO) Info",
      condition: "SINGLESIGNONINFO",
    },
    { value: "22", label: "Work Order", condition: "WORKORDER" },
    {
      value: "23",
      label: "Look API Integration",
      condition: "LOOKAPIINTEGRATION",
    },
  ];

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };

  const CompanyInformationRef = useRef(null);
  const TaxesRef = useRef(null);
  const CurrencyRef = useRef(null);
  const PaymentTypesRef = useRef(null);
  const PriceRulesRef = useRef(null);
  const OrdersAndDeliveriesRef = useRef(null);
  const SalesRef = useRef(null);
  const SuspendedSalesLaywaysRef = useRef(null);
  const ReceiptRef = useRef(null);
  const ProfitCalculationRef = useRef(null);
  const BarcodeRef = useRef(null);
  const CustomerLoyaltyRef = useRef(null);
  const PriceTiersRef = useRef(null);
  const IDNumbersRef = useRef(null);
  const ItemsRef = useRef(null);
  const EmployeeRef = useRef(null);
  const StoreAccountRef = useRef(null);
  const DisableModulesRef = useRef(null);
  const ApplicationSettingsRef = useRef(null);
  const EmailSettingsRef = useRef(null);
  const SingleSignOnInfoRef = useRef(null);
  console.log(EmailSettingsRef,"datafinder");
  const WorkOrderRef = useRef(null);
  const LookAPIIntegrationRef = useRef(null);

  const handleStatusDropdown = (event) => {
    if (event && event.condition === "COMPANYINFORMATION") {
      setCompanyInformation(true);
      CompanyInformationRef.current.scrollIntoView({ behavior: "smooth" });
      // window.scrollTo(80, 80);
    } else if (event && event.condition === "TAXES") {
      setVisibleTax(true);
      TaxesRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "CURRENCY") {
      setVisibleCurrency(true);
      CurrencyRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "PAYMENTTYPES") {
      setVisiblePaymentTypes(true);
      PaymentTypesRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "PRICERULES") {
      setVisiblePriceRules(true);
      PriceRulesRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "ORDERSANDDELIVERIES") {
      setVisibleOrdersAndDeliveries(true);
      OrdersAndDeliveriesRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "SALES") {
      setVisibleSales(true);
      SalesRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "SUSPENDEDSALES") {
      setVisibleSuspendedSalesLayways(true);
      SuspendedSalesLaywaysRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "RECEIPT") {
      setVisibleReceipt(true);
      ReceiptRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "PROFITCALCULATION") {
      setVisibleProfitCalculation(true);
      ProfitCalculationRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "BARCODE") {
      setVisibleBarcodes(true);
      BarcodeRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "CUSTOMERLOYALTY") {
      setVisibleCustomerLoyalty(true);
      CustomerLoyaltyRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "PRICETIERS") {
      setVisiblePriceTiers(true);
      PriceTiersRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "IDNUMBERS") {
      setVisibleIDNumbers(true);
      IDNumbersRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "ITEMS") {
      setVisibleItems(true);
      ItemsRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "EMPLOYEE") {
      setVisibleEmployee(true);
      EmployeeRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "STOREACCOUNT") {
      setVisibleStoreAccount(true);
      StoreAccountRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "DISABLEMODULES") {
      setVisibleDisableModules(true);
      DisableModulesRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "APPLICATIONSETTINGS") {
      setVisibleApplicationSettings(true);
      ApplicationSettingsRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "EMAILSETTINGS") {
      setVisibleEmailSettings(true);
      EmailSettingsRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "SINGLESIGNONINFO") {
      setVisibleSingleSignOnInfo(true);
      SingleSignOnInfoRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "WORKORDER") {
      setVisibleWorkOrder(true);
      WorkOrderRef.current.scrollIntoView({ behavior: "smooth" });
    } else if (event && event.condition === "LOOKAPIINTEGRATION") {
      setVisibleLookAPIIntegration(true);
      LookAPIIntegrationRef.current.scrollIntoView({ behavior: "smooth" });
    } else {
      setVisibleTax(false);
      setCompanyInformation(false);
      setVisibleCurrency(false);
      setVisiblePaymentTypes(false);
      setVisiblePriceRules(false);
      setVisibleOrdersAndDeliveries(false);
      setVisibleSales(false);
      setVisibleSuspendedSalesLayways(false);
      setVisibleReceipt(false);
      setVisibleProfitCalculation(false);
      setVisibleBarcodes(false);
      setVisibleCustomerLoyalty(false);
      setVisiblePriceTiers(false);
      setVisibleIDNumbers(false);
      setVisibleItems(false);
      setVisibleEmployee(false);
      setVisibleStoreAccount(false);
      setVisibleDisableModules(false);
      setVisibleApplicationSettings(false);
      setVisibleEmailSettings(false);
      setVisibleSingleSignOnInfo(false);
      setVisibleWorkOrder(false);
      setVisibleLookAPIIntegration(false);
    }
    setSelectedOption(event);
  };
  const [query, setQuery] = useState("");

  const options = [
    "company information",
    "taxes",
    "currency",
    "payment types",
    "price rules",
    "orders and deliveries",
    "sales",
    "suspended sales/layways",
    "receipt",
    "profit calculation",
    "barcodes",
    "customer loyalty",
    "price tiers",
    "id numbers",
    "items",
    "employee",
    "store account",
    "disable modules",
    "application settings",
    "email settings",
    "single sign on info",
    "work order",
    "look api integration",
  ];

  const handleQueryChange = (event) => {
    setQuery(event.target.value);
    const matches = stringSimilarity.findBestMatch(event.target.value, options);

    if (matches.bestMatch.rating >= 0.6) {
      switch (matches.bestMatch.target) {
        case "company information":
          setCompanyInformation(true);
          CompanyInformationRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "taxes":
          setVisibleTax(true);
          TaxesRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "currency":
          setVisibleCurrency(true);
          CurrencyRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "payment types":
          setVisiblePaymentTypes(true);
          PaymentTypesRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "price rules":
          setVisiblePriceRules(true);
          PriceRulesRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "orders and deliveries":
          setVisibleOrdersAndDeliveries(true);
          OrdersAndDeliveriesRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "sales":
          setVisibleSales(true);
          SalesRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "suspended sales layaways":
          setVisibleSuspendedSalesLayways(true);
          SuspendedSalesLaywaysRef.current.scrollIntoView({
            behavior: "smooth",
          });
          break;
        case "receipt":
          setVisibleReceipt(true);
          ReceiptRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "profit calculation":
          setVisibleProfitCalculation(true);
          ProfitCalculationRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "barcodes":
          setVisibleBarcodes(true);
          BarcodeRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "customer loyalty":
          setVisibleCustomerLoyalty(true);
          CustomerLoyaltyRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "price tiers":
          setVisiblePriceTiers(true);
          PriceTiersRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "id numbers":
          setVisibleIDNumbers(true);
          IDNumbersRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "items":
          setVisibleItems(true);
          ItemsRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "employee":
          setVisibleEmployee(true);
          EmployeeRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "store account":
          setVisibleStoreAccount(true);
          StoreAccountRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "disable modules":
          setVisibleDisableModules(true);
          DisableModulesRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "application settings":
          setVisibleApplicationSettings(true);
          ApplicationSettingsRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "email settings":
          setVisibleEmailSettings(true);
          EmailSettingsRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "single sign on info":
          setVisibleSingleSignOnInfo(true);
          SingleSignOnInfoRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "work order":
          setVisibleWorkOrder(true);
          WorkOrderRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "look api integration":
          setVisibleLookAPIIntegration(true);
          LookAPIIntegrationRef.current.scrollIntoView({ behavior: "smooth" });
          break;

        // Add more cases for other options here
        default:
          setVisibleTax(false);
          setCompanyInformation(false);
          setVisibleCurrency(false);
          setVisiblePaymentTypes(false);
          setVisiblePriceRules(false);
          setVisibleOrdersAndDeliveries(false);
          setVisibleSales(false);
          setVisibleSuspendedSalesLayways(false);
          setVisibleReceipt(false);
          setVisibleProfitCalculation(false);
          setVisibleBarcodes(false);
          setVisibleCustomerLoyalty(false);
          setVisiblePriceTiers(false);
          setVisibleIDNumbers(false);
          setVisibleItems(false);
          setVisibleEmployee(false);
          setVisibleStoreAccount(false);
          setVisibleDisableModules(false);
          setVisibleApplicationSettings(false);
          setVisibleEmailSettings(false);
          setVisibleSingleSignOnInfo(false);
          setVisibleWorkOrder(false);
          setVisibleLookAPIIntegration(false);
          break;
      }
    }
    setSelectedOption(event);
  };


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper card-head">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header"
            style={
              {
                position: "fixed",
                top: "2px",
                zIndex: "999"
              }
            }
          >
            <div className="row breadcrumb-position" >
              {/* <div className="col"> */}
                {/* <h3 className="page-title">Store Config</h3> */}
                <ul className="breadcrumb">
                  <li className="breadcrumb-item" style={{marginLeft:"12px"}}>
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Manage Store Config</li>
                </ul>
              {/* </div> */}
            </div>
          </div>

          <div className="col-md-12">
            {/* email-template */}
            <div className="card">
              <div className="card-header">
                <div className="row">
                  {/* search */}
                  {/* <div className="col-md-3 me-4">
                    <input
                      type="search"
                      placeholder="Search..."
                      className="search-btn form-control"
                      onChange={handleQueryChange}
                      value={query}
                    />
                  </div> */}
                  {/* <button onClick={handleSearch}>Search</button> */}
                  {/* dropdown */}
                  <div className="d-flex flex-wrap w-25">
                    <input
                      type="search"
                      placeholder="Search..."
                      className="search-btn form-control form-control-sm w-100"
                      onChange={handleSearchChange}
                      value={searchQuery}
                    />
                  </div>
                  <div className="col-md-4">
                    <Select
                      onChange={(event) => handleStatusDropdown(event)}
                      options={optionList}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="Config"
                      name="Config"
                      className="custom-search-select"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Company Information */}
          <div ref={CompanyInformationRef}>
            <CompanyInformation visibleInformationChange={companyInformation} searchQuery={searchQuery} />
          </div>

          {/* Taxes */}
          <div ref={TaxesRef}>
            <Taxes visibleTaxChange={visibleTax} searchQuery={searchQuery} />
          </div>

          {/* Currency */}
          <div ref={CurrencyRef}>
            <Currency visibleCurrencyChange={visibleCurrency} searchQuery={searchQuery} />
          </div>

          {/* Payment Types */}
          <div ref={PaymentTypesRef}>
            <PaymentTypes visiblePaymentTypesChange={visiblePaymentTypes} searchQuery={searchQuery} />
          </div>

          {/* Price Rules */}
          <div ref={PriceRulesRef}>
            <PriceRules visiblePriceRulesChange={visiblePriceRules} searchQuery={searchQuery} />
          </div>

          {/* Orders And Deliveries */}
          <div ref={OrdersAndDeliveriesRef}>
            <OrdersAndDeliveries
              visibleOrdersAndDeliveriesChange={visibleOrdersAndDeliveries}
              searchQuery={searchQuery}
            />
          </div>

          {/* Sales */}
          <div ref={SalesRef}>
            <Sales visibleSalesChange={visibleSales} searchQuery={searchQuery} />
          </div>

          {/* Suspended Sales/Layways */}
          <div ref={SuspendedSalesLaywaysRef}>
            <SuspendedSalesLayways
              visibleSuspendedSalesChange={visibleSuspendedSalesLayways} searchQuery={searchQuery} />
          </div>

          {/* Receipt */}
          <div ref={ReceiptRef}>
            <Receipt visibleReceiptChange={visibleReceipt} searchQuery={searchQuery} />
          </div>

          {/* Profit Calculation */}
          <div ref={ProfitCalculationRef}>
            <ProfitCalculation
              visibleProfitCalculationchange={visibleProfitCalculation} searchQuery={searchQuery}
            />
          </div>

          {/* Barcodes */}
          <div ref={BarcodeRef}>
            <Barcodes visibleBarcodesChange={visibleBarcodes} searchQuery={searchQuery} />
          </div>

          {/* Customer Loyalty */}
          <div ref={CustomerLoyaltyRef}>
            <CustomerLoyalty
              visibleCustomerLoyaltyChange={visibleCustomerLoyalty} searchQuery={searchQuery}
            />
          </div>

          {/* Price Tiers */}
          <div ref={PriceTiersRef}>
            <PriceTiers visiblePriceTiersChange={visiblePriceTiers} searchQuery={searchQuery} />
          </div>

          {/* ID Numbers */}
          <div ref={IDNumbersRef}>
            <IDNumbers visibleIDNumbersChange={visibleIDNumbers} searchQuery={searchQuery} />
          </div>

          {/* Items */}
          <div ref={ItemsRef}>
            <Items visibleItemsChange={visibleItems} searchQuery={searchQuery} />
          </div>

          {/* Employee */}
          <div ref={EmployeeRef}>
            <Employee visibleEmployeeChange={visibleEmployee} searchQuery={searchQuery} />
          </div>

          {/* Store Account */}
          <div ref={StoreAccountRef}>
            <StoreAccount visibleStoreAccountChange={visibleStoreAccount} searchQuery={searchQuery} />
          </div>

          {/* Disable Modules */}
          <div ref={DisableModulesRef}>
            <DisableModules
              visibleDisableModulesChange={visibleDisableModules} searchQuery={searchQuery}
            />
          </div>

          {/* Application Settings */}
          <div ref={ApplicationSettingsRef}>
            <ApplicationSettings
              visibleApplicationSettingsChange={visibleApplicationSettings} searchQuery={searchQuery}
            />
          </div>

          {/* Email Settings */}
          <div ref={EmailSettingsRef}>
            <EmailSettings visibleEmailSettingsChange={visibleEmailSettings} searchQuery={searchQuery} />
          </div>

          {/* Single Sign On (SSO) Info */}
          <div ref={SingleSignOnInfoRef}>
            <SingleSignOnInfo
              visibleSingleSignOnInfoChanges={visibleSingleSignOnInfo} searchQuery={searchQuery}
            />
          </div>

          {/* Work Order */}
          <div ref={WorkOrderRef}>
            <WorkOrder visibleWorkOrderChange={visibleWorkOrder} searchQuery={searchQuery} />
          </div>

          {/* Look API Intergration */}
          <div ref={LookAPIIntegrationRef}>
            <LookAPIIntergration
              visibleLookAPIIntegrationChange={visibleLookAPIIntegration} searchQuery={searchQuery}
            />
          </div>

          {/* <button type="submit" className="submit_button floating-button btn btn-primary pull-right">
            Save
          </button> */}
        </div>
      </div>
    </>
  );
};

export default FormElements;
